import { QueryClient } from "@tanstack/react-query";

/** Refresh invoice, ledger, and subscription views after a payment. */
export async function invalidateBillingQueries(
  queryClient: QueryClient,
  orgId?: string,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["unpaidInvoices"] }),
    queryClient.invalidateQueries({ queryKey: ["invoices"] }),
    queryClient.invalidateQueries({ queryKey: ["billingLedger"] }),
    queryClient.invalidateQueries({ queryKey: ["billingHistory"] }),
    queryClient.invalidateQueries({ queryKey: ["subscription"] }),
    queryClient.invalidateQueries({ queryKey: ["entitlements"] }),
    orgId
      ? queryClient.invalidateQueries({ queryKey: ["paymentMethods", orgId] })
      : Promise.resolve(),
  ]);
  await Promise.all([
    queryClient.refetchQueries({ queryKey: ["unpaidInvoices"] }),
    queryClient.refetchQueries({ queryKey: ["invoices"] }),
    queryClient.refetchQueries({ queryKey: ["billingLedger"] }),
    queryClient.refetchQueries({ queryKey: ["entitlements"] }),
  ]);
}
